import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Text } from '~/components/core';
import { useStyles } from '~/hooks';
import { FONT_SIZE_L, FONT_SIZE_S } from '~/constants/typography';
import { scaleSize } from '~/constants/scale';
import { Theme } from '~/theme';

import CircularProgress from '../../CircularProgress';

type Props = {
    // Percent from the progress socket; null while queued -> indeterminate ring.
    percent: number | null;
    queued: boolean;
};

// Body for created/inprogress strategies: progress ring + a single static line. The live
// per-generation engine feed is intentionally not surfaced — it reads as noise to users.
export default function ProgressBody({ percent, queued }: Props) {
    const styles = useStyles(stylesGenerator);
    return (
        <View style={styles.container}>
            <Text fontType="LATO_BOLD" style={styles.title}>
                {queued ? 'ai-strategy-processing-queued' : 'ai-strategy-processing-title'}
            </Text>
            <CircularProgress percent={queued ? null : percent} size={scaleSize(140)} />
            <Text style={styles.hint}>ai-strategy-processing-hint</Text>
        </View>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        container: {
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            padding: scaleSize(24),
        },
        title: {
            fontSize: FONT_SIZE_L,
            color: theme.text,
            marginBottom: scaleSize(24),
            textAlign: 'center',
        },
        hint: {
            fontSize: FONT_SIZE_S,
            color: theme.textSecondary,
            marginTop: scaleSize(10),
            textAlign: 'center',
            fontStyle: 'italic',
        },
    });
